var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal-base',{staticClass:"modal-student-history",attrs:{"width":1024,"height":120}},[_c('student-information-history',{attrs:{"student":_vm.student,"prevPage":_vm.prevPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }